import { Link } from "react-router-dom";

import "./footer.css";

function footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-box">
          <div className="footer-logo">
            <p className="footer-logo-title">SERVED</p>
            <p className="footer-logo-sub">
              Private DMCA Enforcement & Verified Creator Network
            </p>
          </div>

          <div className="footer-box-links">
            <h4>Resources</h4>
            <ul>
              <li>
                <Link to="/faq">FAQs</Link>
              </li>

              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </div>

          <div className="footer-box-links">
            <h4>Legal</h4>
            <ul>
              <li>
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          <p>Copyright @2026 Served Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default footer;
